type DurationUnit = number | null | undefined;

export const formatDurationUnitsToText = (months: DurationUnit, days: DurationUnit, hours: DurationUnit, minutes: DurationUnit): string =>
  [
    months ? `${months} month${months !== 1 ? 's' : ''}` : null,
    days ? `${days} day${days !== 1 ? 's' : ''}` : null,
    hours ? `${hours} hour${hours !== 1 ? 's' : ''}` : null,
    minutes ? `${minutes} minute${minutes !== 1 ? 's' : ''}` : null,
  ]
    .filter(Boolean)
    .join(', ');
